export const containsUppercase = (str: string) => {
  return /[A-Z]/.test(str)
}
export const validateEmail = (email: string) => {
  return /[a-zA-Z0-9_#!$%&`'*+-{|}~^/=?.]+@([a-zA-Z0-9-]+\.)+([a-z]+)/.test(email)
}
